import { render } from "./ExpertisesPage.vue?vue&type=template&id=3ea88a26"
import script from "./ExpertisesPage.vue?vue&type=script&lang=js"
export * from "./ExpertisesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__